import Gangway from 'gangway'

const API = Gangway({
  baseURL: '/api',
  onResponse(response) {
    return response.body.data
  }
})

API.resource('games')

API.route({
  gifs: {
    read: {
      baseURL: 'https://api.giphy.com',
      path   : '/v1/gifs/search',
      query  : {
        api_key : 'dc6zaTOxFJmzC',
        limit   : 25,
        rating  : 'pg-13'
      }
    }
  }
})

export default API



/** WEBPACK FOOTER **
 ** ./web/static/lib/api.js
 **/